import { createQuery } from '../common';
import { getMetadataTimeRange } from '../apis';

export const QUERY_KEY_METADATA_TIME_RANGE = `/gm/v1/metadata/time_range` as const;

export const useMetadataTimeRange = createQuery({
  queryKey: [QUERY_KEY_METADATA_TIME_RANGE],
  queryFn: getMetadataTimeRange,
  cacheTime: Infinity,
  staleTime: Infinity,
});
